<template>
  <div class="bg-nav">
    <!-- NAVBAR -->
    <div>
      <Navbar />
    </div>
    <div
      class="bg-products-cot h-auto mb-12 mt-8"
      style="height: auto !important"
      v-if="quotationData && showForm"
    >
      <div class="container mx-auto mb-24">
        <div class="w-full flex cursor-pointer mb-3" @click="$router.back()">
          <ChevronLeftIcon class="block text-theme-9" />
          <div class="text-center text-sm text-theme-9 font-medium">
            Regresar
          </div>
        </div>
        <div class="mb-12">
          <h1 class="font-crimson_pro text-3xl font-bold text-theme-9">
            Solicitud {{ quotationData.id }}
          </h1>
        </div>
        <template v-if="quotationData.status === 'SENT'">
          <div class="col-span-4">
            <img
              src="@/assets/images/COT-bg/reloj.png"
              alt="empty"
              class="m-auto"
            />
          </div>
          <div class="container mb-10">
            <h4 class="text-center font-poppins">
              Aún no te han respondido a esta cotización
            </h4>
          </div>
        </template>
        <template v-if="quotationData.status === 'CLOSE'">
          <div class="col-span-4">
            <img
              src="@/assets/images/COT-bg/clip.png"
              alt="empty"
              class="m-auto"
            />
          </div>
          <div class="container mb-10">
            <h4 class="text-center font-poppins">
              Esta cotización ha finalizado
            </h4>
          </div>
        </template>
        <div class="flex w-full" v-if="quotationData.admin_id">
          <div
            class="flex flex-col justify-center items-center rounded-[10px] border border-white mx-auto p-2"
          >
            <div class="flex flex-row">
              <div class="w-16 h-16 image-fit relative mr-5">
                <img
                  alt="Imagen de usuario"
                  class="rounded-full"
                  :src="getUserImage(quotationData.admin || {})"
                  crossorigin="anonymous"
                />
              </div>
              <div class="flex flex-col">
                <span class="font-poppins text-theme-32">
                  Responsable de la solicitud</span
                >
                <span class="font-poppins text-black text-lg font-medium">
                  {{ quotationData.admin?.name }}
                  {{ quotationData.admin?.last_name }}
                </span>
              </div>
            </div>
            <div
              class="w-full flex flex-row items-center mx-auto justify-center"
              v-html="getSvgByStatus(quotationData.status)"
            />
          </div>
        </div>
        <div
          v-if="quotationData.status === 'COUNTERPROPOSAL'"
          class="flex flex-col w-full border border-white p-2 sm:p-5 my-5 rounded-[10px]"
        >
          <p>
            Queremos informarte que, debido a algunos ajustes relacionados con
            logística y/o disponibilidad de inventario, hemos realizado una
            contrapropuesta sobre la cotización que solicitaste.
          </p>
          <div class="flex flex-col sm:flex-row w-full gap-2">
            <button
              type="button"
              @click="handleOpenInfoModal('reject')"
              class="btn btn-quotation-outline rounded-lg px-5 w-full sm:w-2/4 mr-4 text-base hover:bg-theme-6 hover:text-white"
            >
              Rechazar
            </button>
            <button
              type="button"
              @click="handleOpenInfoModal('edit')"
              class="btn btn-quotation-outline rounded-lg px-5 w-full sm:w-2/4 mr-4 text-base hover:bg-theme-6 hover:text-white"
            >
              Editar propuesta
            </button>
            <button
              type="button"
              @click="handleOpenInfoModal('accept')"
              class="btn btn-quotation-outline rounded-lg px-5 w-full sm:w-2/4 mr-4 text-base hover:bg-theme-6 hover:text-white"
            >
              Aceptar
            </button>
          </div>
        </div>
        <div class="w-full flex flex-col">
          <span class="font-poppins text-black text-xl font-semibold">
            Mensajes realizados
          </span>
          <div
            class="w-4/5 flex mt-10 border-2 border-solid border-white p-5"
            :class="{
              'ml-auto': message.user_id === this.$store.state?.auth?.user?.id,
              'mr-auto': message.user_id !== this.$store.state?.auth?.user?.id
            }"
            v-for="message in chatMessages"
            :key="message.id"
          >
            <div class="flex flex-col w-full">
              <div class="flex">
                <div class="w-16 h-16 image-fit relative mr-5">
                  <img
                    alt="Imagen de usuario"
                    class="rounded-full"
                    :src="getUserImage(message.user || {})"
                    crossorigin="anonymous"
                  />
                </div>
                <div class="flex flex-col">
                  <span class="font-poppins text-gray-600 text-base">
                    {{ message.user.name }}
                    {{ message.user.last_name }}
                  </span>
                  <span class="font-poppins text-theme-32 text-xs">
                    {{ getTimeMessage(message.created_at) }}
                  </span>
                </div>
              </div>
              <div class="flex mt-5">
                <p class="font-poppins text-base">
                  {{ stripHtml(message.message) }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <template v-if="quotationData.status !== 'CLOSE'">
          <div class="w-full mt-7">
            <ClassicEditor
              v-model="chatMessageText"
              :editor="classicEditor"
              :config="{
                toolbar: ['bold', 'italic', 'undo']
              }"
            />
          </div>
          <div class="w-full mt-3 flex justify-end">
            <button
              type="button"
              class="btn-quotation text-base font-semibold rounded-lg w-60 h-14 font-poppins text-center disabled:cursor-not-allowed disabled:opacity-30"
              :disabled="
                !(this.chatMessageText?.length && !this.sendingMessage)
              "
              @click="sendMessage"
            >
              Enviar
            </button>
          </div>
        </template>
      </div>
      <div class="container">
        <!-- CATALOGUE -->
        <div class="grid grid-cols-12 gap-4 mb-6">
          <div class="sm:col-span-4 col-span-12 text-right">
            <div
              class="rounded-3xl container"
              style="backdrop-filter: blur(8px) brightness(100%)"
            >
              <div class="mx-auto py-0 h-auto">
                <span
                  class="relative top-10 right-6 z-10"
                  @click="changeFavoriteProduct(quotationData.product_id)"
                >
                  <HeartIcon
                    class="font-poppins font-medium fill-current cursor-pointer"
                    :class="{
                      'text-transparent':
                        !quotationData?.product?.users_favorite?.length,
                      'text-theme-9':
                        quotationData?.product?.users_favorite?.length
                    }"
                    :style="{
                      stroke: !quotationData?.product?.users_favorite?.length
                        ? '#a13122'
                        : 'currentColor'
                    }"
                  />
                </span>
                <div
                  class="inline-grid flex-row-reverse lg:flex rounded-lg border shadow-lg pb-6 lg:pb-0 lg:px-32 px-6"
                  style="
                    border: 3px solid #ffffff47;
                    height: 480px;
                    width: 100%;
                    margin: 0;
                    border-radius: 20px;
                  "
                >
                  <div class="w-full lg:p-4 pt-6">
                    <img
                      :src="getProductImage(quotationData.product)"
                      alt="Imagen del producto de cotización"
                      class="h-96 object-contain object-center w-full"
                      crossorigin="anonymous"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="grid grid-cols-2 gap-4 text-left bg-white p-4 mt-10 mb-6 shadow-sm rounded-2xl"
            >
              <div>
                <h3 class="font-poppins text-theme-32 text-xs">
                  No. de cajas master
                </h3>
                <h2 class="font-poppins text-black font-bold text-base">
                  {{
                    numberFormatter.format(
                      lastQuotationStatus.custom_total_master_boxes
                    )
                  }}
                </h2>
                <h3 class="font-poppins text-theme-32 text-xs">
                  Tiempos de entrega
                </h3>
                <h2 class="font-poppins text-black font-bold text-base">
                  {{
                    numberFormatter.format(
                      Number(lastQuotationStatus.custom_days_approx_delivery) +
                        Number(
                          lastQuotationStatus.custom_days_approx_customization
                        ) +
                        Number(lastQuotationStatus.custom_days_approx_shipping)
                    )
                  }}
                  días
                </h2>
              </div>
              <div>
                <h3 class="font-poppins text-theme-32 text-xs">Precio base</h3>
                <h2 class="font-poppins text-black font-bold text-base">
                  {{
                    historicBasePrice.toLocaleString('es-Mx', {
                      style: 'currency',
                      currency: 'MXN'
                    })
                  }}
                  MXN
                </h2>
                <h3 class="font-poppins text-theme-32 text-xs">
                  Subtotal (Con envío estándar)
                </h3>
                <h2 class="font-poppins text-theme-33 font-bold text-base">
                  {{
                    formatter.format(
                      lastHistoricPrice?.historic_final_price ||
                        lastHistoricPrice?.final_price ||
                        0
                    )
                  }}
                  MXN
                </h2>
              </div>
            </div>
          </div>
          <div class="sm:col-span-8 col-span-12 pl-4">
            <div>
              <h1 class="font-crimson_pro font-bold text-3xl text-theme-9">
                {{ quotationData.product?.name }}
              </h1>
              <h6 class="text-theme-32 text-xs">
                SKU: {{ quotationData.product?.sku }}
              </h6>
            </div>
            <div class="mt-3">
              <p class="font-poppins text-base">
                {{ quotationData.product?.description }}
              </p>
            </div>
            <div class="flex mt-3">
              <h1
                class="font-poppins font-medium text-base text-center align-middle align-items-lg-start py-2 mr-2"
              >
                Temporalidad:
              </h1>
              <template
                v-if="
                  Array.isArray(quotationData.product?.categories) &&
                  quotationData.product.categories.length
                "
              >
                <span
                  class="w-32 h-9 rounded-md bg-theme-7 text-white text-center align-middle align-items-lg-start p-2 mr-2"
                  v-for="category in quotationData.product?.categories || []"
                  :key="category.id"
                >
                  {{ category.name }}
                </span>
              </template>
              <span
                class="w-32 h-9 rounded-md bg-theme-7 text-white text-center align-middle align-items-lg-start p-2 mr-2"
                v-else
              >
                Sin temporalidad
              </span>
            </div>
            <div v-if="isCpaCompany" class="flex">
              <h1
                class="font-poppins font-medium text-base text-center align-middle align-items-lg-start py-2"
              >
                Tipo de canal:
              </h1>
              <span
                class="w-96 h-9 rounded-md align-middle align-items-lg-start py-2 ml-2 font-poppins text-base font-normal"
              >
                {{ quotationData.channel?.name || '-' }}
              </span>
            </div>
            <div class="mt-3">
              <h1 class="font-poppins font-medium text-base py-2">Color</h1>
              <div class="grid grid-cols-12 gap-1">
                <div>
                  <a
                    href="javascript:;"
                    class="color-picker"
                    :style="{ background: quotationData.color }"
                  ></a>
                </div>
              </div>
            </div>
            <div>
              <div v-if="isCpaCompany" class="mt-3 w-full">
                <label class="form-label w-full font-poppins text-sm">
                  Cliente
                </label>
                <span class="w-full font-poppins text-sm">
                  {{ quotationData.brand?.client?.name }}
                </span>
              </div>
              <div v-if="isCpaCompany" class="mt-3 w-full">
                <label class="form-label w-full font-poppins text-sm">
                  Marca
                </label>
                <span class="w-full font-poppins text-sm">
                  {{ quotationData.brand?.name }}
                </span>
              </div>
              <div class="mt-3">
                <label class="form-label w-full font-poppins text-sm">
                  Tipo de impresión
                </label>
                <span class="w-full font-poppins text-sm">
                  {{ lastQuotationStatus?.print_type?.name }}
                </span>
              </div>
              <div class="mt-3">
                <label class="form-label w-full font-poppins text-sm"
                  >Tintas de impresión
                </label>
                <span class="w-full font-poppins text-sm">
                  {{ getStringInkValue(lastQuotationStatus?.max_number_inks) }}
                </span>
              </div>
              <div class="mt-3">
                <label class="form-label w-full font-poppins text-sm">
                  Número de posiciones
                </label>
                <span class="w-full font-poppins text-sm">
                  {{ lastHistoricPrice?.number_of_positions || 1 }}
                </span>
              </div>
              <div class="mt-3">
                <label
                  for="regular-form-1"
                  class="form-label w-full font-poppins text-sm font-bold"
                  >Volumen de venta (pzas)</label
                >
                <span class="w-full font-poppins text-sm font-bold">
                  {{ numberFormatter.format(lastHistoricPrice?.units || 0) }}
                </span>
              </div>
              <template v-if="quotationData.special_quotation">
                <div class="mt-3">
                  <div class="input-form mt-3">
                    <label
                      class="form-label w-full font-poppins text-sm flex flex-col sm:flex-row"
                    >
                      Requerimientos adicionales
                    </label>
                    <span class="w-full font-poppins text-sm">
                      {{ lastQuotationStatus.additional_requirements }}
                    </span>
                  </div>
                </div>
                <template v-if="lastQuotationStatus.file">
                  <div class="mt-3">Archivo de distribución</div>
                  <div class="mt-3 text-theme-33">
                    <a
                      :href="lastQuotationStatus.file"
                      download
                      target="_blank"
                      rel="noreferrer"
                    >
                      Descargar Archivo
                    </a>
                  </div>
                </template>
              </template>
              <div class="mt-3">
                <h1 class="font-bold text-lg font-poppins">Especificaciones</h1>
              </div>
              <div class="mt-3">
                <div class="grid grid-cols-5 gap-4">
                  <div>
                    <button
                      class="w-40 h-10 rounded font-poppins"
                      :class="{
                        'bg-theme-29': informationSelected === 'BASIC',
                        'text-black': informationSelected === 'BASIC',
                        'bg-transparent': informationSelected !== 'BASIC',
                        border: informationSelected !== 'BASIC',
                        'border-theme-3': informationSelected !== 'BASIC'
                      }"
                      @click="informationSelected = 'BASIC'"
                    >
                      Inf. básica
                    </button>
                  </div>
                  <div>
                    <button
                      class="w-40 h-10 rounded font-poppins"
                      :class="{
                        'bg-theme-29': informationSelected === 'PRINTING',
                        'text-black': informationSelected === 'PRINTING',
                        'bg-transparent': informationSelected !== 'PRINTING',
                        border: informationSelected !== 'PRINTING',
                        'border-theme-3': informationSelected !== 'PRINTING'
                      }"
                      @click="informationSelected = 'PRINTING'"
                    >
                      Inf. de impresión
                    </button>
                  </div>
                  <div>
                    <button
                      class="w-40 h-10 rounded font-poppins"
                      :class="{
                        'bg-theme-29': informationSelected === 'PACKAGING',
                        'text-black': informationSelected === 'PACKAGING',
                        'bg-transparent': informationSelected !== 'PACKAGING',
                        border: informationSelected !== 'PACKAGING',
                        'border-theme-3': informationSelected !== 'PACKAGING'
                      }"
                      @click="informationSelected = 'PACKAGING'"
                    >
                      Inf. de empaque
                    </button>
                  </div>
                </div>
                <div class="mt-3">
                  <div class="overflow-x-auto">
                    <table
                      style="width: 100%; text-align: left"
                      class="font-poppins"
                      aria-describedby="Información del producto"
                    >
                      <template v-if="informationSelected === 'BASIC'">
                        <tr>
                          <th>Categoría</th>
                          <td>{{ quotationData.product.material?.name }}</td>
                        </tr>
                        <tr>
                          <th>Medida</th>
                          <td>
                            {{ quotationData.product.length }} x
                            {{ quotationData.product.width }} x
                            {{ quotationData.product.height }} cm
                          </td>
                        </tr>
                        <tr>
                          <th>Capacidad</th>
                          <td>
                            {{ quotationData.product.unit_measure || '-' }}
                          </td>
                        </tr>
                      </template>
                      <template v-else-if="informationSelected === 'PRINTING'">
                        <tr>
                          <th>Técnica</th>
                          <td>{{ printingTypesDescription }}</td>
                        </tr>
                        <tr>
                          <th v-if="isSerigrafiaTampografia">Tintas</th>
                          <th v-else>Área</th>
                          <td>{{ printingAreasDescription }}</td>
                        </tr>
                      </template>
                      <template v-else-if="informationSelected === 'PACKAGING'">
                        <tr>
                          <th>Medida caja master</th>
                          <td>
                            {{
                              quotationData.product?.containerbox?.length || '-'
                            }}
                            x
                            {{
                              quotationData.product?.containerbox?.width || '-'
                            }}
                            x
                            {{
                              quotationData.product?.containerbox?.height || '-'
                            }}
                            cm ({{
                              quotationData.product?.containerbox?.masterbox
                                ?.box_type?.siz || '-'
                            }})
                          </td>
                        </tr>
                        <tr>
                          <th>Peso</th>
                          <td>{{ quotationData.product.weight }} gramos</td>
                        </tr>
                        <tr>
                          <th>Caja individual</th>
                          <td>{{ checkContainerBox ? 'Sí' : 'No' }}</td>
                        </tr>
                        <tr>
                          <th>Cantidad de piezas x caja master</th>
                          <td>
                            {{
                              quotationData.product.containerbox?.masterbox
                                ?.max_total_containers || '-'
                            }}
                            pza(s)
                          </td>
                        </tr>
                      </template>
                    </table>
                  </div>
                </div>
                <div class="mt-6">
                  <h1 class="font-bold font-poppins text-lg">NOTAS</h1>
                  <ul class="font-poppins text-base list-disc mt-3">
                    <li>
                      El costo de envío es variable, ponte en contacto con tu
                      ejecutivo de ventas para más información.
                    </li>
                    <li>Los costos de los productos NO incluyen IVA.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="quotationData && showForm">
    <Footer />
  </div>
  <InfoModal
    v-model="isOpenInfoModal"
    :type="infoModalType"
    @click:action="handleAction"
  />
</template>

<script>
import Navbar from '@/components/navbar/Main.vue'
import Footer from '@/components/footer/Main.vue'
import InfoModal from '@/components/quotation/InfoModal.vue'
import {
  cleanSession,
  getFirstErrorMessage,
  formatter,
  numberFormatter
} from '@/utils/tools'
import moment from 'moment-timezone'
import Ably from 'ably'
import TimeAgo from 'javascript-time-ago'
import es from 'javascript-time-ago/locale/es'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  components: {
    Navbar,
    Footer,
    InfoModal
  },
  data() {
    return {
      creatingQuotation: false,
      formatter: formatter,
      numberFormatter: numberFormatter,
      showForm: false,
      quotationData: undefined,
      informationSelected: 'BASIC',
      moment: moment,
      classicEditor: ClassicEditor,
      ablyData: {
        ably: undefined,
        socketId: undefined,
        channel: undefined,
        event: 'App\\Events\\MessageQuotationEvent',
        channelName: undefined,
        channelNameDefault: 'private:message.'
      },
      timeAgo: undefined,
      chatMessages: [],
      chatMessageText: '',
      sendingMessage: false,
      lastHistoric: undefined,
      previousHistoric: undefined,
      isOpenInfoModal: false,
      infoModalType: ''
    }
  },
  async beforeMount() {
    this.$store.commit('main/setShowSpinner', true)
    TimeAgo.addLocale(es)
    this.timeAgo = new TimeAgo('es-MX')
    await this.ablySetup()
    await this.loadData()
    this.$store.commit('main/setShowSpinner', false)
  },
  async beforeUnmount() {
    await this.ablyUnsubscribeData()
    if (this.ablyData.ably) {
      try {
        this.ablyData.ably.close()
      } catch (e) {
        console.error(e)
      }
      this.ablyData.ably = undefined
    }
  },
  methods: {
    async loadData() {
      this.showForm = false
      await this.ablyUnsubscribeData()
      const quotationId = +this.$route.params.id
      await this.getQuotationData(quotationId)
      await this.ablySubscribeData(quotationId)
      this.showForm = true
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    async ablySetup() {
      if (this.ablyData.ably && this.ablyData.ably.connection.state !== 'closed') {
        return true
      }
      const key = process.env.VUE_APP_ABLY_KEY
      const ablyOptions = key && key.trim() !== ''
        ? { key: key.trim() }
        : {
            authUrl: `${process.env.VUE_APP_BASE_API_URL}/broadcasting/auth`,
            authHeaders: {
              Authorization: `Bearer ${this.$store?.state?.auth?.token || ''}`,
              Accept: 'application/json'
            }
          }
      this.ablyData.ably = new Ably.Realtime(ablyOptions)
      return true
    },
    async ablySubscribeData(quotationId) {
      await this.ablySetup()
      this.ablyData.channelName = `${this.ablyData.channelNameDefault}${quotationId}`
      this.ablyData.channel = this.ablyData.ably.channels.get(
        this.ablyData.channelName
      )
      if (process.env.NODE_ENV !== 'production' && this.ablyData.channel.on) {
        this.ablyData.channel.on((stateChange) => {
          if (stateChange.current === 'attached') {
            console.log(`[Ably Sales] Suscrito exitosamente al canal: ${this.ablyData.channelName}`)
          }
        })
      }
      const handleMessage = (message) => {
        const payload = typeof message.data === 'string' ? JSON.parse(message.data) : message.data
        const chatMessage = payload?.message || payload
        if (chatMessage && (chatMessage.id || chatMessage.text)) {
          const exists = chatMessage.id && this.chatMessages.some((m) => +m.id === +chatMessage.id)
          if (!exists) {
            this.chatMessages.push(chatMessage)
          }
        }
      }
      this.ablyData.channel.subscribe(handleMessage)
    },
    async ablyUnsubscribeData() {
      return new Promise((resolve, reject) => {
        try {
          if (this.ablyData.channel) {
            this.ablyData.channel.unsubscribe()
            this.ablyData.channel = undefined
          }
          resolve(true)
        } catch (error) {
          console.error(error)
          reject(error)
        }
      })
    },
    async getQuotationData(quotationId) {
      try {
        this.quotationData = undefined
        this.lastHistoric = {}
        this.previousHistoric = undefined
        const response = await this.axios.get(
          `sales-operator/quotations/${quotationId}/data`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        const quotationData = response.data?.quotation
        // ORDER DESC
        if (Array.isArray(quotationData?.historic_prices)) {
          this.lastHistoric = quotationData?.historic_prices[0] || {}
          this.previousHistoric = quotationData?.historic_prices[1]
        }
        this.chatMessages = [...(quotationData?.messages || [])]
        this.quotationData = quotationData
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    getProductImage(product) {
      return Array.isArray(product.image) && product.image.length
        ? product.image[0]
        : require(product.sku !== 'COTESPI001'
            ? '@/assets/images/product.svg'
            : '@/assets/images/COTESPI001.svg')
    },
    getUserImage(user) {
      return Array.isArray(user.avatar) && user.avatar.length
        ? user.avatar[0]
        : require('@/assets/images/user.svg')
    },
    getTimeMessage(timeMessage) {
      return this.timeAgo.format(
        moment(timeMessage || new Date())
          .tz('America/Mexico_City')
          .toDate()
      )
    },
    async changeFavoriteProduct(productId) {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post(
          'sales-operator/favorite-products/edit-favorite-product',
          {
            product_id: productId
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        await this.loadData()
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    getStringInkValue(ink) {
      switch (true) {
        case ink === 1:
          return '1 tinta'
        case ink > 1:
          return `${ink} tintas`
        case ink >= 6:
          return '6 tintas o más'
        default:
          return ink
      }
    },
    async sendMessage() {
      if (this.chatMessageText?.length && !this.sendingMessage) {
        this.sendingMessage = true
        try {
          await this.axios.post(
            `common/quotations/${this.quotationData.id}/create-message-quotation`,
            {
              message: this.chatMessageText
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
                // 'X-Socket-Id': this.pusherData.socketId
              }
            }
          )
          // if (response.data?.message) {
          //   this.chatMessages.push(response.data?.message)
          // }
        } catch (error) {
          if (error?.response?.status === 401) {
            this.$toast.error('Su sesión ha expirado', {
              position: 'top'
            })
            return cleanSession(this.$store, this.$router)
          }
          this.$toast.error(getFirstErrorMessage(error), {
            position: 'top'
          })
        } finally {
          this.chatMessageText = ''
          this.sendingMessage = false
        }
      }
    },
    stripHtml(html) {
      const tmp = document.createElement('DIV')
      tmp.innerHTML = html
      return tmp.textContent || tmp.innerText || ''
    },
    getSvgByStatus(status) {
      switch (status) {
        case 'SENT':
          return `
            <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="25" height="25" rx="12.5" fill="#64748B"/>
            <g clip-path="url(#clip0_7271_15597)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9529 6.73529C12.2252 6.73529 11.5237 6.88969 10.8856 7.15681C10.2532 7.42151 9.67779 7.81215 9.19792 8.29202C8.72083 8.76911 8.33573 9.34517 8.06033 9.98529C7.789 10.6159 7.64119 11.3152 7.64119 12.0471C7.64119 12.7748 7.79559 13.4763 8.06271 14.1144C8.11821 14.247 8.12573 14.3948 8.08397 14.5324L7.04461 17.9554L10.4676 16.9161C10.6072 16.8737 10.7572 16.8821 10.8912 16.9397C11.5218 17.211 12.2211 17.3588 12.9529 17.3588C13.6807 17.3588 14.3822 17.2044 15.0203 16.9373C15.6527 16.6726 16.2281 16.2819 16.708 15.8021C17.1851 15.325 17.5702 14.7489 17.8456 14.1088C18.1169 13.4782 18.2647 12.7789 18.2647 12.0471C18.2647 11.3193 18.1103 10.6178 17.8432 9.97969C17.5785 9.34733 17.1878 8.77189 16.708 8.29202C16.2309 7.81493 15.6548 7.42982 15.0147 7.15443C14.3841 6.8831 13.6848 6.73529 12.9529 6.73529ZM10.4086 6.01732C11.1869 5.69149 12.0501 5.5 12.9529 5.5C13.8516 5.5 14.7171 5.68161 15.5029 6.0197C16.2793 6.35371 16.988 6.82505 17.5815 7.41854C18.1722 8.00926 18.6544 8.71858 18.9827 9.50269C19.3085 10.2811 19.5 11.1442 19.5 12.0471C19.5 12.9458 19.3184 13.8112 18.9803 14.597C18.6463 15.3734 18.1749 16.082 17.5815 16.6755C16.9908 17.2662 16.2815 17.7486 15.4973 18.0768C14.719 18.4026 13.8558 18.5941 12.9529 18.5941C12.135 18.5941 11.3446 18.4437 10.6167 18.1618L6.29711 19.4733C6.07898 19.5396 5.84211 19.4803 5.68092 19.3191C5.51973 19.1579 5.46043 18.921 5.52666 18.7029L6.83907 14.3806C6.56468 13.6584 6.4059 12.8692 6.4059 12.0471C6.4059 11.1484 6.58752 10.2829 6.9256 9.49709C7.25961 8.72074 7.73094 8.01203 8.32444 7.41854C8.91516 6.82782 9.62445 6.34556 10.4086 6.01732Z" fill="white"/>
            </g>
            <defs>
            <clipPath id="clip0_7271_15597">
            <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
            </clipPath>
            </defs>
            </svg>
            Solicitada
          `
        case 'IN PROCESS':
          return `
            <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="25" height="25" rx="12.5" fill="#EF5DA8"/>
            <g clip-path="url(#clip0_7271_15593)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.1546 12.5C10.1546 13.7935 11.2065 14.8454 12.5 14.8454C13.7934 14.8454 14.8453 13.7935 14.8453 12.5C14.8453 11.2066 13.7934 10.1547 12.5 10.1547C11.2065 10.1547 10.1546 11.2066 10.1546 12.5ZM11.3545 12.5008C11.3545 11.8689 11.868 11.3554 12.5 11.3554C13.1311 11.3554 13.6454 11.8689 13.6454 12.5008C13.6454 13.1328 13.1319 13.6463 12.5 13.6463C11.868 13.6463 11.3545 13.1328 11.3545 12.5008Z" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7826 17.7106C10.7826 18.6977 11.5737 19.5 12.5464 19.5C13.5023 19.5 14.3102 18.6689 14.311 17.689C14.3118 17.5314 14.4094 17.361 14.5358 17.3074C14.6598 17.2531 14.8453 17.2947 14.9517 17.3986C15.646 18.0922 16.7707 18.0954 17.4586 17.4082C17.793 17.0739 17.973 16.6243 17.9658 16.1436C17.9594 15.6716 17.7722 15.2293 17.445 14.9021C17.3378 14.7925 17.2995 14.6142 17.3554 14.4878C17.3562 14.4854 17.357 14.4838 17.3578 14.4814C17.4106 14.3582 17.5634 14.2646 17.7106 14.2638C18.6977 14.2638 19.5 13.4727 19.5 12.5C19.5 11.5441 18.6697 10.7362 17.689 10.7362C17.5418 10.7354 17.365 10.6218 17.3075 10.4882C17.2507 10.3618 17.2963 10.1539 17.3986 10.0491C18.0922 9.35396 18.0962 8.22929 17.4082 7.54217C17.0739 7.2078 16.6395 7.02782 16.1436 7.03502C15.6716 7.04142 15.2293 7.2286 14.9021 7.55576C14.7925 7.66215 14.6142 7.70055 14.4814 7.64215C14.3582 7.58936 14.2646 7.43658 14.2638 7.2894C14.2638 6.30231 13.4727 5.5 12.5 5.5C11.5441 5.5 10.7362 6.33031 10.7362 7.31099C10.7354 7.45818 10.6218 7.63496 10.4882 7.69255C10.3626 7.75014 10.1539 7.70375 10.0491 7.60136C9.35396 6.90704 8.22929 6.90384 7.54217 7.59176C7.20781 7.92612 7.02783 8.37567 7.03503 8.85642C7.04142 9.32836 7.2286 9.77071 7.55577 10.0979C7.66295 10.2067 7.70135 10.385 7.63096 10.5474C7.58296 10.6778 7.43018 10.7794 7.2894 10.7826C6.30231 10.7826 5.5 11.5737 5.5 12.5464C5.5 13.5023 6.33031 14.3102 7.31099 14.3102C7.46858 14.311 7.63896 14.4086 7.69255 14.535C7.74774 14.6598 7.70535 14.8437 7.60136 14.9509C6.90784 15.646 6.90384 16.7707 7.59176 17.4578C7.92612 17.7922 8.36367 17.9594 8.85642 17.965C9.32836 17.9586 9.77071 17.7714 10.0979 17.4442C10.2067 17.3378 10.3858 17.3003 10.5474 17.369C10.6778 17.417 10.7794 17.5698 10.7826 17.7106ZM10.997 16.2572C10.801 16.1708 10.5922 16.1284 10.3826 16.1284C9.97309 16.1284 9.56274 16.2884 9.25317 16.5907C9.0276 16.8155 8.65404 16.8243 8.43806 16.6075C8.22209 16.3924 8.22689 16.0212 8.45406 15.794C8.91001 15.3277 9.0444 14.627 8.79242 14.0558C8.55085 13.4935 7.95812 13.1127 7.31339 13.1103C6.98623 13.1103 6.69986 12.8464 6.69986 12.5464C6.69986 12.2408 6.96943 11.9825 7.303 11.9825C7.95412 11.9673 8.53805 11.5569 8.74283 10.997C8.998 10.4194 8.86602 9.72032 8.40927 9.25317C8.18369 9.0276 8.1757 8.65484 8.39247 8.43806C8.60765 8.22209 8.978 8.22769 9.20598 8.45406C9.66832 8.90681 10.3962 9.04439 10.9674 8.79242C11.5353 8.54845 11.9337 7.94212 11.9361 7.31339C11.9361 6.98623 12.2 6.69986 12.5 6.69986C12.8056 6.69986 13.0639 6.96943 13.0639 7.2918C13.0671 7.91972 13.4463 8.50446 14.003 8.74283C14.5814 8.9988 15.2797 8.86522 15.7468 8.40927C15.9724 8.18449 16.3452 8.17649 16.5619 8.39247C16.7779 8.60764 16.7731 8.9788 16.5459 9.20598C16.0932 9.66912 15.9556 10.3962 16.2076 10.9674C16.4515 11.5353 17.0579 11.9337 17.6866 11.9361C18.0138 11.9361 18.3001 12.2 18.3001 12.5C18.3001 12.8056 18.0306 13.0639 17.7082 13.0639C17.0811 13.0671 16.4987 13.4447 16.2564 14.0054C16.002 14.5822 16.1348 15.2805 16.5907 15.7468C16.8163 15.9724 16.8243 16.3452 16.6075 16.5619C16.3924 16.7787 16.022 16.7723 15.794 16.5459C15.3277 16.0908 14.627 15.9556 14.0558 16.2076C13.4935 16.4491 13.1127 17.0419 13.1103 17.6866C13.1103 18.0138 12.8464 18.3001 12.5464 18.3001C12.2408 18.3001 11.9825 18.0306 11.9825 17.697C11.9673 17.0459 11.5569 16.4619 10.997 16.2572Z" fill="white"/>
            </g>
            <defs>
            <clipPath id="clip0_7271_15593">
            <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
            </clipPath>
            </defs>
            </svg>
            En proceso
          `
        case 'ACCEPTED':
          return `
              <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="25" height="25" rx="12.5" fill="#3B82F6"/>
              <g clip-path="url(#clip0_7271_15588)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M19.3243 7.67574C19.5586 7.91005 19.5586 8.28995 19.3243 8.52426L10.5243 17.3243C10.2899 17.5586 9.91005 17.5586 9.67574 17.3243L5.67574 13.3243C5.44142 13.0899 5.44142 12.7101 5.67574 12.4757C5.91005 12.2414 6.28995 12.2414 6.52426 12.4757L10.1 16.0515L18.4757 7.67574C18.71 7.44142 19.0899 7.44142 19.3243 7.67574Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_7271_15588">
              <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
              </clipPath>
              </defs>
              </svg>
              Aceptada
            `
        case 'COUNTERPROPOSAL':
          return `
              <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="25" height="25" rx="12.5" fill="#F97316"/>
              <g clip-path="url(#clip0_7271_15580)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9235 6.52426C13.1578 6.28995 13.1578 5.91005 12.9235 5.67574C12.6892 5.44142 12.3093 5.44142 12.075 5.67574L9.67495 8.07574C9.44064 8.31005 9.44064 8.68995 9.67495 8.92426L12.075 11.3243C12.3093 11.5586 12.6892 11.5586 12.9235 11.3243C13.1578 11.0899 13.1578 10.7101 12.9235 10.4757L11.5477 9.1H12.4992C15.0398 9.1 17.0992 11.1594 17.0992 13.7C17.0992 16.2406 15.0398 18.3 12.4992 18.3C9.95859 18.3 7.89922 16.2406 7.89922 13.7C7.89922 13.3686 7.63059 13.1 7.29922 13.1C6.96785 13.1 6.69922 13.3686 6.69922 13.7C6.69922 16.9034 9.29585 19.5 12.4992 19.5C15.7026 19.5 18.2992 16.9034 18.2992 13.7C18.2992 10.4966 15.7026 7.9 12.4992 7.9H11.5477L12.9235 6.52426Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_7271_15580">
              <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
              </clipPath>
              </defs>
              </svg>
              Contrapropuesta
            `
        case 'WON':
          return `
              <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="25" height="25" rx="12.5" fill="#16A34A"/>
              <g clip-path="url(#clip0_7271_15615)">
              <path d="M18.4396 6.46073C18.2764 6.34792 18.0683 6.32391 17.8827 6.39752C16.9626 6.75677 15.3816 7.26404 14.9015 7.21283C14.4543 7.16242 13.7462 6.79277 13.0605 6.43433C12.2004 5.98467 11.3867 5.56062 10.681 5.50461C9.65366 5.4326 7.19174 6.2255 6.70848 6.38792C6.46365 6.47033 6.29883 6.69916 6.29883 6.9568V8.66261V13.7817V18.8999C6.29883 19.2312 6.56766 19.5 6.8989 19.5C7.23015 19.5 7.49898 19.2312 7.49898 18.8999V14.2177C8.55272 13.8849 10.0545 13.4784 10.585 13.5272C11.0474 13.5632 11.8211 13.9681 12.5036 14.3241C13.3221 14.7514 14.0958 15.1554 14.7655 15.2315C14.8215 15.2379 14.8823 15.2411 14.9479 15.2411C15.9649 15.2411 17.9163 14.4986 18.3188 14.3409C18.5484 14.2513 18.7004 14.0289 18.7004 13.7825V6.9576C18.702 6.75757 18.6044 6.57275 18.4396 6.46073ZM17.5019 13.3664C16.5633 13.7097 15.3288 14.0777 14.9023 14.0385C14.4551 13.9881 13.747 13.6184 13.0613 13.26C12.2012 12.8103 11.3875 12.3855 10.6818 12.3295C10.6322 12.3255 10.5786 12.3239 10.5226 12.3239C9.74247 12.3239 8.38869 12.6911 7.50058 12.9608V8.66181V7.39205C8.55192 7.06081 10.0577 6.64876 10.5866 6.70156C11.049 6.73757 11.8227 7.14242 12.5052 7.49846C13.3237 7.92572 14.0974 8.32897 14.7671 8.40498C15.4128 8.48019 16.653 8.10814 17.5011 7.81611V13.3664H17.5019Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_7271_15615">
              <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
              </clipPath>
              </defs>
              </svg>
              Cotización aceptada
            `
        case 'LOSS':
          return `
              <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="25" height="25" rx="12.5" fill="#CE0100"/>
              <g clip-path="url(#clip0_7271_15607)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 6.66667C9.27834 6.66667 6.66667 9.27834 6.66667 12.5C6.66667 15.7217 9.27834 18.3333 12.5 18.3333C15.7217 18.3333 18.3333 15.7217 18.3333 12.5C18.3333 9.27834 15.7217 6.66667 12.5 6.66667ZM5.5 12.5C5.5 8.63401 8.63401 5.5 12.5 5.5C16.366 5.5 19.5 8.63401 19.5 12.5C19.5 16.366 16.366 19.5 12.5 19.5C8.63401 19.5 5.5 16.366 5.5 12.5ZM15.2458 9.75419C15.4736 9.98199 15.4736 10.3513 15.2458 10.5791L13.325 12.5L15.2458 14.4209C15.4736 14.6487 15.4736 15.018 15.2458 15.2458C15.018 15.4736 14.6487 15.4736 14.4209 15.2458L12.5 13.325L10.5791 15.2458C10.3513 15.4736 9.98199 15.4736 9.75419 15.2458C9.52638 15.018 9.52638 14.6487 9.75419 14.4209L11.675 12.5L9.75419 10.5791C9.52638 10.3513 9.52638 9.98199 9.75419 9.75419C9.98199 9.52638 10.3513 9.52638 10.5791 9.75419L12.5 11.675L14.4209 9.75419C14.6487 9.52638 15.018 9.52638 15.2458 9.75419Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_7271_15607">
              <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
              </clipPath>
              </defs>
              </svg>
              Rechazada
            `
        case 'REQUOTING':
          return `
              <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="25" height="25" rx="12.5" fill="#A855F7"/>
              <g clip-path="url(#clip0_7271_15611)">
              <path d="M9.47132 17.6073H8.33618C7.81478 17.6073 7.39024 17.1828 7.39024 16.6614V7.58032C7.39024 7.05891 7.81478 6.63437 8.33618 6.63437H11.174V10.229C11.174 10.5423 11.4283 10.7965 11.7416 10.7965H15.374C15.4527 11.016 15.657 11.1749 15.9038 11.1749C16.217 11.1749 16.4713 10.9206 16.4713 10.6073V10.229C16.4713 10.1533 16.4562 10.0791 16.4274 10.0103C16.3987 9.94141 16.357 9.87935 16.3056 9.82789L12.1434 5.66573C12.0912 5.61351 12.0299 5.57265 11.961 5.54389C11.8922 5.51513 11.818 5.5 11.7423 5.5H8.33694C7.18894 5.5 6.25586 6.43308 6.25586 7.58108V16.6622C6.25586 17.8102 7.18894 18.7432 8.33694 18.7432H9.47208C9.78537 18.7432 10.0396 18.489 10.0396 18.1757C10.0396 17.8624 9.78462 17.6073 9.47132 17.6073ZM12.3092 7.43654L14.5333 9.66065H12.3092V7.43654ZM18.2595 12.0255C17.9697 11.7357 17.5505 11.5639 17.11 11.5541C16.656 11.5283 16.2284 11.7062 15.9348 11.9998L11.0961 16.8461C11.0007 16.9414 10.9425 17.0678 10.9311 17.2025L10.7956 18.887C10.782 19.0535 10.8433 19.2185 10.9629 19.3358C11.0696 19.4417 11.2134 19.5 11.3617 19.5C11.3783 19.5 11.3958 19.4992 11.4132 19.4977L13.1143 19.3426C13.2468 19.3297 13.3701 19.2722 13.464 19.1784L18.3027 14.3329C18.9066 13.7305 18.8854 12.6521 18.2595 12.0255ZM17.5013 13.5292L12.8079 18.2294L11.983 18.3051L12.0473 17.5014L16.7385 12.8027C16.8126 12.7285 16.9481 12.693 17.0843 12.6892C17.2334 12.693 17.3726 12.7444 17.4559 12.8292C17.6345 13.0055 17.6579 13.3725 17.5013 13.5292Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_7271_15611">
              <rect x="5.5" y="5.5" width="14" height="14" fill="white"/>
              </clipPath>
              </defs>
              </svg>
              Recotizada
            `
        case 'CLOSE':
          return `
              <svg
                  class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12.5" cy="12.5" r="12.5" fill="#27AE60"/>
                  <path d="M11.2313 15.1282L8.53904 12.4359L7.6416 13.3334L11.2313 16.9231L18.9237 9.23081L18.0262 8.33337L11.2313 15.1282Z" fill="white"/>
              </svg>
              Finalizado
            `
      }
    },
    handleOpenInfoModal(type) {
      this.infoModalType = type
      this.isOpenInfoModal = true
    },
    async handleAction() {
      this.$store.commit('main/setShowSpinner', true)
      this.isOpenInfoModal = false
      if (this.infoModalType === 'accept') {
        try {
          await this.axios.put(
            `sales-operator/quotations/${this.quotationData.id}`,
            {
              status: 'WON'
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            }
          )
          this.$toast.success('Cotización aceptada', {
            position: 'top'
          })
          this.getQuotationData(this.quotationData.id)
          this.$store.commit('main/setShowSpinner', false)
        } catch (error) {
          if (error?.response?.status === 401) {
            this.$toast.error('Su sesión ha expirado', {
              position: 'top'
            })
            return cleanSession(this.$store, this.$router)
          }
        }
      } else if (this.infoModalType === 'reject') {
        try {
          await this.axios.put(
            `sales-operator/quotations/${this.quotationData.id}`,
            {
              status: 'LOSS'
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            }
          )
          this.$toast.success('Cotización rechazada', {
            position: 'top'
          })
          this.getQuotationData(this.quotationData.id)
          this.$store.commit('main/setShowSpinner', false)
        } catch (error) {
          if (error?.response?.status === 401) {
            this.$toast.error('Su sesión ha expirado', {
              position: 'top'
            })
            return cleanSession(this.$store, this.$router)
          }
        }
      } else if (this.infoModalType === 'edit') {
        this.$router.push(
          `/products/${this.quotationData.product_id}?quotationId=${this.quotationData.id}&status=edit`
        )
        this.$store.commit('main/setShowSpinner', false)
      }
    }
  },
  computed: {
    isCpaCompany() {
      return this.company?.code == 'cpa'
    },
    printingTypesDescription() {
      return this.lastQuotationStatus?.print_type.name
    },
    printingAreasDescription() {
      return this.lastQuotationStatus.printing_area
    },
    isSerigrafiaTampografia() {
      return (
        this.printingTypesDescription
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .includes('tampografia') ||
        this.printingTypesDescription
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .includes('serigrafia')
      )
    },
    checkContainerBox() {
      return (
        this.quotationData?.product?.containerbox?.length &&
        this.quotationData?.product?.containerbox?.width &&
        this.quotationData?.product?.containerbox?.height
      )
    },
    historicBasePrice() {
      if (this.lastHistoricPrice) {
        let utility = 1

        if (
          this.lastHistoricPrice?.historic_percentage_utility ||
          this.lastHistoricPrice?.percentage_utility
        ) {
          utility =
            1 -
            (this.lastHistoricPrice?.historic_percentage_utility ||
              this.lastHistoricPrice?.percentage_utility) /
              100
        }

        return (
          Number(
            Number(
              this.lastHistoricPrice?.historic_base_price ||
                this.lastHistoricPrice?.base_price ||
                0
            ) +
              Number(
                this.lastHistoricPrice?.historic_cost_per_impression ||
                  this.lastHistoricPrice?.cost_per_impression ||
                  0
              ) +
              Number(
                this.lastHistoricPrice?.historic_packaging_price_by_container ||
                  this.lastHistoricPrice?.packaging_price_by_container ||
                  0
              )
          ) / utility
        )
      }
      return 0
    },
    lastQuotationStatus() {
      const statuses = this.quotationData?.quotation_statuses
      if (statuses?.length) {
        return statuses[0]
      }
      return this.quotationData
    },
    lastHistoricPrice() {
      if (this.lastQuotationStatus?.quotation_status_historic_prices?.length) {
        return this.lastQuotationStatus?.quotation_status_historic_prices[
          this.lastQuotationStatus?.quotation_status_historic_prices.length - 1
        ]
      }

      if (this.lastQuotationStatus?.historic_prices?.length) {
        return this.lastQuotationStatus?.historic_prices[
          this.lastQuotationStatus?.historic_prices.length - 1
        ]
      }

      return null
    }
  },
  watch: {
    '$route.params': async function () {
      if (this.$route.params?.id) {
        this.$store.commit('main/setShowSpinner', true)
        await this.loadData()
        this.$store.commit('main/setShowSpinner', false)
      }
    }
  }
}
</script>

<style scoped>
.bg-nav {
  background: url('@/assets/images/COT-bg/img-slider-nav.svg');
  background-repeat: no-repeat;
  background-position: initial;
  backface-visibility: hidden;
  height: auto;
  width: auto;
}

.bg-banner-2 {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: initial;
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-geometria {
  background: url('@/assets/images/COT-bg/img-geometria.svg');
  background-repeat: no-repeat;
  background-position: center;
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-cat-bg {
  background: url('@/assets/images/COT-bg/img-categorias.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 60px;
  width: auto;
  padding-top: 2px;
}

.bg-banner {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  backdrop-filter: blur(8px) brightness(100%);
  border: 3px solid rgba(255, 255, 255, 0.28);
}

.backtest {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
}

.bg-banner-cot {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 198px;
  width: auto;
  padding-top: 0px;
  margin-bottom: 18rem;
}

.bg-banner-cot-res {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 445px;
  width: auto;
  padding-top: 0px;
}

.bg-products-cot {
  background: url('@/assets/images/COT-bg/img-products.svg');
  background-repeat: no-repeat;
  background-position: inherit;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 230px;
  width: auto;
  padding-top: 2px;
}

.bg-help {
  background: url('@/assets/images/COT-bg/img-help.svg');
  background-repeat: no-repeat;
  background-position: right;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 350px;
  width: auto;
  padding-top: 2px;
}

.btn-deg {
  background: linear-gradient(89.75deg, #e85c04 0.17%, #faa306 99.78%);
  transition: 0.3s;
  outline: 1px solid transparent;
  width: 200px;
  font-weight: 600;
}

.b-cot-card {
  background-image: radial-gradient(
      circle at 100% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to right, #ffffff, #ffffff),
    radial-gradient(
      circle at 0% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to bottom, #ffffff, #f6f6e0),
    radial-gradient(
      circle at 0% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 21px
    ),
    linear-gradient(to left, #ffffff21, #ffffff21),
    radial-gradient(
      circle at 100% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 17px
    ),
    linear-gradient(to top, #ffffff21, #ffffff);
  background-size: 21px 21px, calc(100% - 42px) 3px, 21px 21px,
    3px calc(100% - 42px);
  background-position: top left, top center, top right, center right,
    bottom right, bottom center, bottom left, center left;
  background-repeat: no-repeat;
  border-radius: 24px;
}

.bg-card {
  background: #ffffff21;
  border-radius: 24px;
}

.eventos {
  background-image: url('@/assets/images/COT-img/eventos/fiestas-1.svg');
}

.flip-card {
  background-color: transparent;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  /* Note: backdrop-filter has minimal browser support */
  border-radius: 20px;
}

.flip-card-back {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  border-radius: 20px;
  transform: rotateY(180deg);
}

.brandin-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 16px;
}

/* SEARCH CONTROL CSS */
.form-control {
  border-color: transparent;
}

.input-group > .form-control:focus {
  border-color: transparent;
  box-shadow: inset 0 0 0 1px transparent;
}
.btn-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:active,
.btn-link.active {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:focus,
.btn-link.focus {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:active:focus,
.btn-link.active:focus {
  background-color: rgba(0, 0, 0, 0.05);
}

.i-search {
  border-radius: 6px 0px 0px 6px !important;
  background: rgb(241, 241, 241) !important;
  border-color: #cacaca !important;
  border-bottom-width: 1px !important;
  border-style: solid none solid solid !important;
  border-top-width: 1px !important;
  border-left-width: 1px !important;
  border-right-width: initial !important;
}
.i-search-form {
  background: rgb(241, 241, 241);
  border-color: #cacaca;
  border-bottom-width: 1px;
  border-style: solid solid solid none;
  border-top-width: 1px;
  border-right-width: 1px;
  border-left-width: initial;
  border-radius: 0px 6px 6px 0px;
  box-shadow: 0 0 0;
}
.color-picker {
  box-shadow: 0 0 0;
  width: 24px;
  height: 24px;
  border: none;
  display: inline-block;
  transition: 0.3s all;
  border-radius: 24px;
}
.color-picker:hover {
  -webkit-box-shadow: inset 0px 0px 0px 4px white;
  -moz-box-shadow: inset 0px 0px 0px 4px white;
  box-shadow: inset 0px 0px 0px 4px white;
}
.color-picker-active {
  -webkit-box-shadow: inset 0px 0px 0px 4px white;
  -moz-box-shadow: inset 0px 0px 0px 4px white;
  box-shadow: inset 0px 0px 0px 4px white;
}
.Aqua {
  background: aqua;
}
.White {
  background: #ffffffd6;
}
.Yellow {
  background: #faa306;
}

.Orange {
  background: #e85c04;
}
.Red {
  background: #ce0100;
}
.Beige {
  background: beige;
}
.Gray {
  background: gray;
}
.Pink {
  background: pink;
}
.Green {
  background: green;
}
.Blue {
  background: navy;
}
.Black {
  background: black;
}
.Purple {
  background: purple;
}

.form-check-input[type='checkbox']:checked {
  background-color: #faa306;
  width: 20px;
  height: 20px;
  border: none;
}
.form-check-input[type='checkbox'] {
  width: 20px;
  height: 20px;
  border: 1px solid #cacaca;
}
tr:nth-child(even) {
  background-color: #f1f1f1;
}
tr {
  background-color: white;
}
th {
  padding-left: 16px;
  padding-top: 6px;
  padding-bottom: 6px;
}
</style>
